import React from 'react';
import { Typography } from '@totango-app-team/ui-shared-components';
import PropTypes from 'prop-types';

const LoginMessage = ({ message }) => (
	<>
		<Typography variant="caption" component="div">
			{message}
		</Typography>
		<Typography variant="caption">
			<a className="error-link login-link" href="https://app.totango.com">
				Login instead
			</a>
		</Typography>
	</>
);

const ValidationMessage = ({ reason }) => {
	switch (reason) {
		case 'invalid':
			return <div>Invalid email address</div>;
		case 'competitor':
			return (
				<div>
					Thanks for your interest in Totango! As a competitor, you probably shouldn&lsquo;t be
					looking at our stuff, but you are more than welcome to send your resume to&nbsp;
					<strong>
						<a className="error-link" href="mailto:careers@totango.com">
							careers@totango.com
						</a>
					</strong>
				</div>
			);
		case 'domain':
			return <div>Please use a business email.</div>;
		case 'email_exist':
			return (
				<LoginMessage message="This email is already associated with another Totango service" />
			);
		case 'signup_already_in_progress':
			return (
				<div>
					It seems that you already have a signup in progress. You can click on the link in the
					email you received to see the signup progress.
				</div>
			);
		case 'single_instance_domain':
			return <LoginMessage message="Your domain already has a Totango account" />;
		default:
			return <div>Something went wrong, please try again later.</div>;
	}
};

const EmailValidationError = ({ reason }) => (
	<div style={{ marginBottom: 15 }} className="step-validation create-account invalid">
		<ValidationMessage reason={reason} />
	</div>
);

EmailValidationError.propTypes = {
	reason: PropTypes.string.isRequired,
};

export default EmailValidationError;
